module.exports = __webpack_public_path__ + "img/merchants_icon.265fd983.svg";